import { CateringTranslations } from "./catering-pt-br";

export const CATERING_ES_MX: CateringTranslations = {
	title: "Catering",
	description:
		"Gestiona el catering de tus eventos, recibe propuestas, envía cotizaciones y monitorea todo en un solo lugar.",
	tabs: {
		proposals: "Propuestas",
		settings: "Configuración",
	},
	settingsMenu: {
		proposalOptions: "Opciones de Propuestas",
		servicesAndFormats: "Servicios y formatos",
	},
	feedback: {
		saveSuccess: "Cambios guardados. Se aplicarán a nuevas propuestas.",
		saveError:
			"No se pudieron guardar los cambios. Inténtalo de nuevo en unos instantes.",
	},
	proposalOptions: {
		style: {
			title: "Estilo de la propuesta",
			description: "Personaliza tu propuesta con la identidad de tu empresa.",
		},
		company: {
			label: "Sobre la empresa",
			companyLabel: "Empresa",
			editAria: "Editar datos de la empresa",
		},
		infoBlocks: {
			label: "Bloques de información estándar",
			showLabel: "Mostrar",
			editAria: "Editar {{name}}",
			disabledHint: "Registra los datos de la empresa antes de configurar este bloque.",
			header: "Encabezado",
			footer: "Pie de página",
			payment: "Medios y condiciones de pago",
		},
		templates: {
			title: "Plantillas de propuestas guardadas",
			description: "Gestiona y edita tus plantillas de propuesta.",
			addLabel: "Agregar plantilla",
			emptyMessage: "Ninguna plantilla registrada",
			createdAt: "Creado el {{date}}",
			editAria: "Editar {{name}}",
		},
	},
	editHeader: {
		title: "Personalizar encabezado",
		createTitle: "Crear encabezado",
		saveLabel: "Guardar estilo",
		fields: {
			title: {
				label: "Título",
				placeholder: "Ej.: Propuesta Comercial",
			},
			showSubmissionDate: "Mostrar fecha de envío y lugar",
			showCompanyName: "Mostrar nombre de la empresa solicitante",
			showRepresentativeName: "Mostrar nombre del representante de la empresa",
			text: {
				label: "Texto inicial",
				placeholder:
					"Ej.: Estimados clientes, a continuación presentamos la propuesta comercial según el cronograma del evento.",
				counter: "{{count}}/{{max}} caracteres",
			},
		},
	},
	editFooter: {
		title: "Personalizar pie de página",
		createTitle: "Crear pie de página",
		saveLabel: "Guardar estilo",
		fields: {
			text: {
				label: "Texto final",
				placeholder:
					"Ej.: Agradecemos tu interés y quedamos a tus órdenes para cualquier duda.",
				counter: "{{count}}/{{max}} caracteres",
			},
			showResponsibleName: "Mostrar nombre del responsable del envío de la propuesta",
			showProposalValidity: "Mostrar validez de la propuesta",
		},
	},
	editPayment: {
		title: "Personalizar formas y condiciones de pago",
		createTitle: "Crear formas y condiciones de pago",
		saveLabel: "Guardar estilo",
		methods: {
			creditCard: "Tarjeta de crédito",
			debitCard: "Tarjeta de débito",
			boleto: "Boleto bancario",
			pix: "PIX",
			cash: "Efectivo",
		},
		fields: {
			methods: {
				label: "Formas de pago aceptadas",
			},
			text: {
				label: "Condiciones de pago",
				placeholder:
					"Ej.: Pago del 70% al cierre de la propuesta y 30% hasta 120 horas antes del evento;",
				counter: "{{count}}/{{max}} caracteres",
			},
		},
	},
	editCompany: {
		title: "Editar información",
		createTitle: "Crear información",
		errors: {
			invalidEmail: "Correo electrónico inválido",
			invalidUrl: "Enlace inválido",
			requiredName: "Ingrese el nombre de la empresa",
		},
		saveLabel: "Guardar información",
		sections: {
			info: "Información de la empresa",
			contacts: "Canales de contacto",
			address: "Dirección",
		},
		fields: {
			name: {
				label: "Nombre",
				placeholder: "Escribe el nombre de la empresa",
			},
			cnpj: {
				label: "RFC",
				placeholder: "00.000.000/0000-00",
			},
			site: {
				label: "Sitio web",
				placeholder: "Pega el enlace del sitio",
			},
			logo: {
				label: "Marca",
				cta: "Agregar logo",
				help: "Archivo JPG o PNG con 300x105px.",
			},
			primaryColor: {
				label: "Color principal",
				help: "Elige el color que se aplicará en iconos, textos y botones.",
				placeholder: "#000000",
			},
			mainPhone: {
				label: "Teléfono principal",
				placeholder: "+52 55 0000 0000",
			},
			secondaryPhone: {
				label: "Teléfono secundario",
				placeholder: "+52 55 0000 0000",
			},
			whatsapp: {
				label: "WhatsApp",
				placeholder: "whatsapp.we/9128394",
			},
			email: {
				label: "Correo electrónico",
				placeholder: "contacto@empresa.com",
			},
			socialMedia: {
				label: "Red social",
				placeholder: "instagram/empresa",
			},
			zipCode: {
				label: "Código postal",
				placeholder: "Escribe el código postal",
			},
			street: {
				label: "Dirección",
				placeholder: "Calle, avenida o lugar",
			},
			number: {
				label: "Número",
				placeholder: "Número",
			},
			complement: {
				label: "Complemento",
				placeholder: "Complemento",
			},
		},
	},
	proposalList: {
		filters: {
			searchPlaceholder: "Buscar propuestas",
			statusPlaceholder: "Todos los estatus",
			placePlaceholder: "Todos los places",
		},
		columns: {
			representative: "Representante de la empresa",
			place: "Place",
			sentBy: "Enviado por",
			startsAt: "Inicia el",
			servicesCount: "Servicios",
			servicesTotal: "Importe",
			status: "Estado",
		},
		status: {
			accepted: "Aceptada",
			newResponse: "Nueva respuesta",
			draft: "Borrador",
			sent: "Enviada",
			sendFailed: "Error de envío",
			rejected: "Rechazada",
		},
		emptyMessage: "No se encontraron propuestas",
	},
	servicesAndFormats: {
		itemsCount: {
			one: "{{count}} elemento",
			other: "{{count}} elementos",
		},
		drawerHelperText: "Pulsa Enter para agregar a la lista.",
		services: {
			title: "Servicios registrados",
			description:
				"Gestiona y registra servicios para usar en la creación de propuestas.",
			addLabel: "Agregar servicio",
			emptyMessage: "Ningún servicio registrado",
			drawer: {
				title: "Agregar nuevo servicio",
				inputLabel: "Nombre del servicio",
				inputPlaceholder: "Escribe el nombre del nuevo servicio",
				saveLabel: "Guardar servicio",
			},
			notifications: {
				created: "Servicio(s) creado(s) con éxito.",
				createdPartial: "{{ok}} servicio(s) creado(s), {{failed}} con error.",
				createFailed: "No se pudieron crear los servicios.",
				deleted: "Servicio eliminado con éxito.",
				deleteFailed: "No se pudo eliminar el servicio.",
			},
		},
		formats: {
			title: "Formatos registrados",
			description: "Gestiona y registra formatos para usar en la creación de propuestas.",
			addLabel: "Agregar formato",
			emptyMessage: "Ningún formato registrado",
			drawer: {
				title: "Agregar nuevo formato",
				inputLabel: "Nombre del formato",
				inputPlaceholder: "Escribe el nombre del nuevo formato",
				saveLabel: "Guardar formato",
			},
			notifications: {
				created: "Formato(s) creado(s) con éxito.",
				createdPartial: "{{ok}} formato(s) creado(s), {{failed}} con error.",
				createFailed: "No se pudieron crear los formatos.",
				deleted: "Formato eliminado con éxito.",
				deleteFailed: "No se pudo eliminar el formato.",
			},
		},
	},
};
